import { render, staticRenderFns } from "./TCLAIrrelevantLinks.vue?vue&type=template&id=17b284c8&scoped=true"
import script from "./TCLAIrrelevantLinks.vue?vue&type=script&lang=js"
export * from "./TCLAIrrelevantLinks.vue?vue&type=script&lang=js"
import style0 from "./TCLAIrrelevantLinks.vue?vue&type=style&index=0&id=17b284c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b284c8",
  null
  
)

export default component.exports